import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import * as types from './action-types'
import * as api from './api'

export default function* saga() {
  yield takeLatestApiCall(types.DELIVERY_TEAMS_FETCH_BEGIN, api.listDeliveryTeams)
}
